import {
  LOAD_DATA_START,
  LOAD_DATA_DONE,
  LOAD_DATA_FAIL,
  LOAD_DATA_LIST_START,
  LOAD_DATA_LIST_DONE,
  LOAD_DATA_LIST_FAIL,
} from '../actionTypes';

const INITIAL_STATE = {
  loading: true,
  error: undefined,
  data: {
    badges: {},
    lists: {},
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOAD_DATA_START:
      return { ...state, loading: true, error: undefined };
    case LOAD_DATA_DONE: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: { ...state.data, ...action.payload.data },
      };
    }
    case LOAD_DATA_FAIL: {
      return { ...state, loading: false, error: action.payload.error, data: { ...INITIAL_STATE.data } };
    }
    case LOAD_DATA_LIST_START:
      return { ...state, loading: true, error: undefined };
    case LOAD_DATA_LIST_DONE: {
      return {
        ...state,
        loading: false,
        error: undefined,
        data: {
          ...state.data,
          lists: { ...state.data.lists, [action.payload.data.type]: [...action.payload.data.items] },
        },
      };
    }
    case LOAD_DATA_LIST_FAIL: {
      return { ...state, loading: false, error: action.payload.error, data: { ...state.data } };
    }
    default:
      return state;
  }
}
